import { render, staticRenderFns } from "./DialogUserDetails.vue?vue&type=template&id=59ab264e&scoped=true"
import script from "./DialogUserDetails.vue?vue&type=script&lang=js"
export * from "./DialogUserDetails.vue?vue&type=script&lang=js"
import style0 from "./DialogUserDetails.vue?vue&type=style&index=0&id=59ab264e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab264e",
  null
  
)

export default component.exports